module.exports = __webpack_public_path__ + "img/whatsapp-logo.5e27fb7f.png";